import React from 'react';

const Thumbnail = () => (
  <div className="w-full h-20 rounded-lg bg-zinc-100 dark:bg-zinc-800 p-2 flex flex-col items-start justify-center gap-1 pl-3">
    <div className="w-14 h-2 bg-zinc-300 dark:bg-zinc-600 rounded" />
    <div className="w-10 h-1.5 bg-zinc-200 dark:bg-zinc-700 rounded" />
  </div>
);

export default Thumbnail;
